import { render, staticRenderFns } from "./CommonTab_Form.vue?vue&type=template&id=a6484d58&scoped=true&"
import script from "./CommonTab_Form.vue?vue&type=script&lang=js&"
export * from "./CommonTab_Form.vue?vue&type=script&lang=js&"
import style0 from "./CommonTab_Form.vue?vue&type=style&index=0&id=a6484d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6484d58",
  null
  
)

export default component.exports